import useStore from "../../../store"
import { WizardPictureStep } from "../../ui/wizard"
import { useIsMobile } from "../../../hooks/useIsMobile"
import { compressImage } from "../../../utilities/imageUtilities"

export default function NAPPicture({ title }) {
  const image = useStore((state) => state.NAPImages[title])
  const nextStep = useStore((state) => state.nextStep)
  const setNAPImages = useStore((state) => state.setNAPImages)
  const setCurrentStep = useStore((state) => state.setCurrentStep)
  const editingNapPhoto = useStore((state) => state.editingNapPhoto)
  const setEditingNapPhoto = useStore((state) => state.setEditingNapPhoto)
  const NAPWorkflowLength = useStore((state) => state.NAPWorkflowLength)
  const isMobile = useIsMobile()

  const handleNextStep = () => {
    if (editingNapPhoto) {
      setCurrentStep(NAPWorkflowLength - 2)
    } else {
      nextStep()
    }
    setEditingNapPhoto(false)
  }

  const storeImage = async (image) => {
    const compressedImage = await compressImage(image)
    const reader = new FileReader()

    return new Promise((resolve, reject) => {
      reader.onloadend = () => {
        const current = useStore.getState().NAPImages
        setNAPImages({ ...current, [title]: reader.result })
        resolve()
      }
      reader.onerror = reject
      reader.readAsDataURL(compressedImage)
    })
  }

  const handleSubmit = async (image) => {
    if (image) {
      await storeImage(image)
    }
    handleNextStep()
  }

  const handlePhotoChange = async (image) => {
    if (image) {
      await storeImage(image)
    }
  }

  return(
    <WizardPictureStep
      title={title}
      previewable={true}
      handleSubmit={handleSubmit}
      image={image}
      allowUpload={!isMobile}
      onPhotoChange={isMobile ? null : handlePhotoChange}
    />
  )
}